module.exports = __webpack_public_path__ + "media/images/dragDrop__infoIcon@3x-0447402f1bebf906cd47cbad0cb4dfef.png";